// Tag update type constants
export const TAG_UPDATE_TYPE = {
  TAG: "tag",
  ENTITY_TAG: "entityTag",
} as const;

export type TagUpdateType =
  (typeof TAG_UPDATE_TYPE)[keyof typeof TAG_UPDATE_TYPE];
